<template>
  <div>
    <div class="page-title">批量清洗</div>
    <div class="page-header">
      <div class="all-clean-search">
        <div class="all-clean-search__label">企业名称</div>
        <Input v-model="companyKey" placeholder="请输入企业名称" class="all-clean-search__input" />
        <Button type="primary" class="all-clean-search__btn">查询</Button>
      </div>
    </div>
    <div class="page-content">
      <v-table
        is-horizontal-resize
        style="width: 100%"
        :title-rows="titleRows"
        :columns="columns"
        :table-data="tableData"
        is-vertical-resize
        :vertical-resize-offset='10'
        :title-row-height="30"
        :row-height="30"
        :column-cell-class-name="columnCellClass"
        :cell-merge="cellMerge"
      ></v-table>
    </div>
  </div>
</template>
<script>
import 'vue-easytable/libs/themes-base/index.css'
import { VTable } from 'vue-easytable'
import { deepClone } from '@/utils/common'

export default {
  components: { VTable },
  data() {
    return {
      companyKey: '',
      tableData: [
        { company: '合计', table: '', rule: '', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '22233333222', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司贵州益佰制药股份有限公司贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '商业清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '终端清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '小计', table: '', rule: '', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '商业清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '终端清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '销售-销售模板', rule: '商业清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '销售-销售模板', rule: '终端清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '商业清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '销售-销售模板', rule: '终端清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '合计', table: '', rule: '', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '销售-销售模板', rule: '商业清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '终端清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '小计', table: '', rule: '', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '商业清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '终端清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '商业清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '终端清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '小计', table: '', rule: '', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '商业清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' },
        { company: '贵州益佰制药股份有限公司', table: '流向-销售模板', rule: '终端清洗', allRepeat: '120', allNoRepeat: '23', tocleanAll: '2', toclean0: '2', toclean1: '2', tocleanAbove: '2', tocleanUnsure: '2', tocleanNoRepeat: '2', cleanRepeat: '3', cleanNoRepeat: '1', countRepeat: '3', countNoRepeat: '6' }
      ],
      columns: [
        { field: 'company', title: '客户名称', width: 200, titleAlign: 'center', columnAlign: 'center', isFrozen: true },
        { field: 'table', title: '工作表', width: 160, titleAlign: 'center', columnAlign: 'center', isFrozen: true },
        { field: 'rule', title: '规则', width: 100, titleAlign: 'center', columnAlign: 'center', isFrozen: true },
        { field: 'allRepeat', title: '去重', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true },
        { field: 'allNoRepeat', title: '未去重', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true },
        { field: 'tocleanAll', title: '总数', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true },
        { field: 'toclean0', title: '结果=0', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true },
        { field: 'toclean1', title: '结果=1', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true },
        { field: 'tocleanAbove', title: '结果>1', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true },
        { field: 'tocleanUnsure', title: '不确定', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true },
        { field: 'tocleanNoRepeat', title: '未去重', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true },
        { field: 'cleanRepeat', title: '去重', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true },
        { field: 'cleanNoRepeat', title: '未去重', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true },
        { field: 'countRepeat', title: '去重', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true },
        { field: 'countNoRepeat', title: '未去重', width: 100, titleAlign: 'center', columnAlign: 'center', overflowTitle: true }
      ],
      titleRows: [
        [
          { fields: ['company'], title: '客户名称', titleAlign: 'center', rowspan: 3 },
          { fields: ['table'], title: '工作表', titleAlign: 'center', rowspan: 3 },
          { fields: ['rule'], title: '规则', titleAlign: 'center', rowspan: 3 },
          { fields: ['allRepeat', 'allNoRepeat'], title: '总条数', titleAlign: 'center', colspan: 2 },
          { fields: ['tocleanAll', 'toclean0', 'toclean1', 'tocleanAbove', 'tocleanUnsure', 'tocleanNoRepeat'], title: '待清洗条数', titleAlign: 'center', colspan: 6 },
          { fields: ['cleanRepeat', 'cleanNoRepeat'], title: '已清洗条数', titleAlign: 'center', colspan: 2 },
          { fields: ['countRepeat', 'countNoRepeat'], title: '已结算条数', titleAlign: 'center', colspan: 2 }
        ],
        [
          { fields: ['allRepeat'], title: '去重', titleAlign: 'center', rowspan: 2 },
          { fields: ['allNoRepeat'], title: '未去重', titleAlign: 'center', rowspan: 2 },
          { fields: ['tocleanAll', 'toclean0', 'toclean1', 'tocleanAbove', 'tocleanUnsure'], title: '去重', titleAlign: 'center', colspan: 5 },
          { fields: ['tocleanNoRepeat'], title: '未去重', titleAlign: 'center' },
          { fields: ['cleanRepeat'], title: '去重', titleAlign: 'center', rowspan: 2 },
          { fields: ['cleanNoRepeat'], title: '未去重', titleAlign: 'center', rowspan: 2 },
          { fields: ['cleanRepeat'], title: '去重', titleAlign: 'center', rowspan: 2 },
          { fields: ['cleanNoRepeat'], title: '未去重', titleAlign: 'center', rowspan: 2 }
        ],
        [
          { fields: ['tocleanAll'], title: '总数', titleAlign: 'center' },
          { fields: ['toclean0'], title: '结果=0', titleAlign: 'center' },
          { fields: ['toclean1'], title: '结果=1', titleAlign: 'center' },
          { fields: ['tocleanAbove'], title: '结果>1', titleAlign: 'center' },
          { fields: ['tocleanUnsure'], title: '不确定', titleAlign: 'center' },
          { fields: ['tocleanNoRepeat'], title: '未去重', titleAlign: 'center' }
        ]
      ]
    }
  },
  mounted() {
    this.formatData()
  },
  methods: {
    formatData() {
      const companyList = this.tableData.map(item => item.company)
      companyList.map((item, index) => {
        const mergeNum = this.findRepeat(companyList, index)
        this.tableData[index].companyMerge = mergeNum
      })
      const tableList = this.tableData.map(item => item.table)
      tableList.map((item, index) => {
        const mergeNum = this.findRepeat(tableList, index)
        this.tableData[index].tableMerge = mergeNum
      })
    },
    // 处理小计样式
    columnCellClass(rowIndex, columnName, rowData) {
      if (rowData.company === '合计' || rowData.company === '小计') {
        return 'column-row-all'
      }
    },
    // 处理单元格合并
    cellMerge(rowIndex, rowData, field) {
      if (field === 'company') {
        if (rowData[field] === '合计' || rowData[field] === '小计') {
          return {
            colSpan: 3,
            rowSpan: 1,
            content: '<span>' + rowData[field] + '</span>'
          }
        } else if (this.tableData[rowIndex].companyMerge !== 0) {
          return {
            colSpan: 1,
            rowSpan: this.tableData[rowIndex].companyMerge,
            content: '<span class="merge-cell">' + rowData.company + '</span>'
          }
        }
      } else if (field === 'table') {
        if (this.tableData[rowIndex].companyMerge !== 0 && this.tableData[rowIndex].tableMerge !== 0) {
          return {
            colSpan: 1,
            rowSpan: this.tableData[rowIndex].tableMerge,
            content: '<span class="merge-cell">' + rowData.table + '</span>'
          }
        }
      }
    },
    // 重复几个
    findRepeat(arr, index) {
      const i = deepClone(arr).slice(index, arr.length).findIndex((str) => {
        return arr[index] !== str
      })
      return (index === 0 || (i > 1 && arr[index - 1] !== arr[index])) ? i : 0
    }
  }
}
</script>
<style lang="scss" scoped="">
  .all-clean-search__label {
    display: inline-block;
    line-height: 28px;
    height: 28px;
    margin-right: 10px;
  }
  .all-clean-search__input {
    width: 156px;
    margin-right: 40px;
  }
</style>
<style lang="scss">
  .column-row-all {
    font-weight: bold;
    background: #F3F6F8;
  }
</style>
